module.exports = __webpack_public_path__ + "img/w3_circle_filter_dark.d547da77.d547da77.png";